export default __webpack_public_path__ + "static/media/CurrencyKidzNavLogo.eff430f5.png";